export default {"src":"/_next/static/media/nopay.7612d8b7.svg","height":30,"width":30};